import React, { FC } from 'react';
import clsx from 'clsx';
import styles from './LineProgressBar.module.scss';
import { useTranslation } from 'react-i18next';

export const LINE_PROGRESS_BAR = {
  root: 'line-progress-bar',
  completeImage: 'complete-star'
};

type LineProgressBarProps = React.HTMLAttributes<HTMLElement> & {
  percentComplete: number;
  completeIconImage?: string;
}

export const LineProgressBar : FC<LineProgressBarProps> = ({ className, percentComplete, completeIconImage }) => {

  const { t } = useTranslation();
  const roundedPercentCompleted = percentComplete.toFixed();
  const complete = percentComplete === 100;

  return (
    <div data-testid={LINE_PROGRESS_BAR.root} className={clsx(styles.container, { [styles.complete]: complete }, className)}>
      <div role={'img'} aria-label={t('perks.lineProgress', { progress: roundedPercentCompleted })} className={clsx(styles.lineProgress)} style={{
        width:`${percentComplete}%`
      }} />
      {completeIconImage && complete
      && <img data-testid={LINE_PROGRESS_BAR.completeImage} alt={t('perks.progressBarCompleteAltIcon')} className={styles.completeStar} src={completeIconImage} />}
    </div>
  );

};
